import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { ApplyOnStatus } from '../../../../../../../../typings'
import { messages } from './messages'

type Props = {
  status: ApplyOnStatus
}

export function ApplyLoyaltyOnStatusView(props: Props) {
  const { status } = props

  return (
    <Text variant="detail" tone="secondary">
      <FormattedMessage {...messages.view[status]} />
    </Text>
  )
}
